import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_TAGS } from "../../lib/home-content";

const MarqueeMasthead = () => (
  <section
    aria-hidden="true"
    data-testid="editorial-marquee"
    className="relative bg-[#0F1245] overflow-hidden"
    style={{
      borderTop: "1px solid rgba(255,255,255,0.06)",
      borderBottom: "1px solid rgba(255,255,255,0.06)",
    }}
  >
    <Marquee gradient={false} speed={42} pauseOnHover className="py-2 md:py-2.5">
      {[...MARQUEE_TAGS, ...MARQUEE_TAGS].map((tag, i) => (
        <span key={`${tag}-${i}`} className="flex items-center">
          <span
            className={`whitespace-nowrap leading-none font-medium ${
              i % 2 === 0
                ? "italic text-[#B7E4F4] font-serif-display"
                : "text-white/90 font-serif-display"
            } text-sm md:text-[15px] lg:text-base`}
          >
            {tag}
          </span>
          <span
            aria-hidden="true"
            className="mx-5 md:mx-7 text-[#4A3FCF]"
            style={{ fontSize: "8px", letterSpacing: "0.3em" }}
          >
            ◆
          </span>
        </span>
      ))}
    </Marquee>
  </section>
);

export default MarqueeMasthead;
